import styled from 'styled-components';
import { Media } from 'enums/enumsUIKit';

export const BurgerMenuStyled = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  @media ${Media.notebook} {
    display: none;
  }
`;
